import { createContext } from "react"

//Context for Sidebar visibility
export const roleContext = createContext()

export default roleContext